import React, { useState } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import HomeButton from "../components/HomeButton";

const LoginPage = ({ onNext }) => {
  const [code, setCode] = useState("91");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [requestSent, setRequestSent] = useState(false);
  const [loading, setLoading] = useState(false);

  // popup message state
  const [popup, setPopup] = useState("");

  const fullPhone = `${code}${phone}`;
  const phoneValid = phone.length === 10;

  const showPopup = (msg) => {
    setPopup(msg);
    setTimeout(() => setPopup(""), 8000); // show for 8 seconds
  };

  const handleCta = async () => {
    console.log("CTA Clicked", { requestSent, phoneValid, fullPhone, otp });
    try {
      if (!requestSent) {
        if (!phoneValid) {
          showPopup("Please enter a valid 10-digit phone number");
          return;
        }
        console.log("Requesting OTP for phone", fullPhone);
        setLoading(true);
        // ask parent to request otp (will call HttpService)
        await onNext({ phone: fullPhone });
        setLoading(false);
        setRequestSent(true);
      } else {
        if (!otp) {
          showPopup("Enter OTP");
          return;
        }
        setLoading(true);
        await onNext({ phone: fullPhone, otp });
        setLoading(false);
      }
    } catch (error) {
      if (error.status === 404) {
        showPopup(
          "Please enter the phone number used for order placement. If you haven't placed an order, please contact support.",
        );
      }
      setLoading(false);
    }
  };

  // reset OTP if phone changes after request
  const onPhoneChange = (value) => {
    if (requestSent) {
      setRequestSent(false);
      setOtp("");
    }
    setPhone(value);
  };

  const ctaLabel = requestSent ? "Next" : "Request OTP";
  const ctaDisabled = !phoneValid || (requestSent && otp.length === 0);

  return (
    <MobilePageLayout
      ctaLabel={ctaLabel}
      onCtaClick={handleCta}
      ctaDisabled={ctaDisabled}
    >
      {popup && <div className="popup">{popup}</div>}
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <HomeButton />

      <h2 className="page-title">Login</h2>

      <label className="input-label">Phone:</label>
      <div className="input-row">
        <input
          className="input-code"
          value={code}
          readOnly
          style={{ color: "#999" }}
        />
        <input
          className="input-phone"
          placeholder="Phone number"
          value={phone}
          inputMode="numeric"
          maxLength="10"
          onChange={(e) => onPhoneChange(e.target.value.replace(/\D/g, ""))}
        />
      </div>

      {requestSent ? (
        <>
          <label className="input-label">OTP:</label>
          <div className="input-row">
            <input
              className="input-phone"
              placeholder="OTP code"
              value={otp}
              inputMode="numeric"
              maxLength="4"
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
            />
          </div>
          <label className="input-label">
            Enter the OTP sent to your phone number.
          </label>
        </>
      ) : (
        <label className="input-label">
          Enter your phone number used to create order.
        </label>
      )}

      {loading && <p>Sending an OTP through SMS...</p>}
    </MobilePageLayout>
  );
};

export default LoginPage;
